/**
 * CricClubs match rows (kwata_final_matches) — defensive field access.
 */

import { normalizeWhitespace } from './involvementDrilldown';

export function filterMatchesBySeries(matches, series, sheet) {
  const s = String(series || '');
  const sh = String(sheet || '');
  return (matches || []).filter(
    (m) => String(m.series || '') === s && String(m.series_sheet || '') === sh
  );
}

function groundLabel(m) {
  return (
    m.ground_name ||
    m.ground ||
    m.venue ||
    m.venue_name ||
    m.location ||
    ''
  );
}

export function filterMatchesByGroundName(matches, groundName) {
  const t = normalizeWhitespace(groundName);
  if (!t) return [];
  return (matches || []).filter((m) => normalizeWhitespace(groundLabel(m)) === t);
}

function clubCandidates(m) {
  return [
    m.home_team,
    m.away_team,
    m.home_club,
    m.away_club,
    m.team_a,
    m.team_b,
    m.club,
    m.club_name,
    m.team_name,
  ].filter((x) => x != null && String(x).trim() !== '');
}

export function filterMatchesByClubName(matches, clubName) {
  const t = normalizeWhitespace(clubName).toLowerCase();
  if (!t) return [];
  return (matches || []).filter((m) =>
    clubCandidates(m).some((c) => normalizeWhitespace(c).toLowerCase() === t)
  );
}

/** First few keys to show in match drill-down table (stable order). */
export const MATCH_DISPLAY_KEYS = [
  'series',
  'series_sheet',
  'match_date',
  'date',
  'ground_name',
  'ground',
  'venue',
  'home_team',
  'away_team',
  'home_club',
  'away_club',
  'result',
  'status',
];

export function pickMatchColumns(sampleRow) {
  if (!sampleRow || typeof sampleRow !== 'object') return [];
  const preferred = MATCH_DISPLAY_KEYS.filter((k) => k in sampleRow && sampleRow[k] != null && sampleRow[k] !== '');
  const rest = Object.keys(sampleRow).filter(
    (k) => !preferred.includes(k) && k !== 'id' && sampleRow[k] != null && sampleRow[k] !== ''
  );
  return [...preferred, ...rest].slice(0, 12);
}
